var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { RevoMainMenu } from "./revo-main-menu";
import { reportAppScopesChanges, trackAppLocationChange, } from "../components/util/location-change";
import { menuTranslations } from "../menu/i18n";
import { getCurrentDomain, getSanitizedDomain, getServiceName, } from "../helper/domain";
import { bind } from "decko";
import { axiosCallWithLocalhostFallback } from "../helper/axios";
import { getCookieValue, setCookie } from "../helper/cookies";
import SessionExpiredPortal from "../menu/SessionExpiredPortal";
import { revoBreakpoints } from "../components/util/layoutconstants";
import { persistUserApplicationPath } from "./revo-menu";
import { authCookieExists, scopesFromCookie } from "../helper/scopesfromcookie";
import { betterServiceUrl } from "../helper/serviceurl";
import { userApps } from "./util/app-authorization";
const REVO_MAIN_MENU_OPEN_COOKIE = "TS_revoMainMenuOpen";
export class RevoLoggedInMenu extends React.Component {
    constructor(props) {
        super(props);
        this.menuTranslations = menuTranslations();
        this.hoverDelayTimer = undefined;
        this.HOVER_DELAY_TIMEOUT = 300;
        this.state = {
            mainMenuOpen: RevoLoggedInMenu.isMainMenuOpen(),
            isHovered: false,
            appDrawerOpen: false,
            location: { app: "???", submenu: "???" },
            domain: getCurrentDomain(window.location),
            isAuthorized: authCookieExists(),
            isLoadingAuthorization: false,
            localPingResponse: 200,
            scopes: scopesFromCookie(),
        };
    }
    componentWillMount() {
        this.checkAuthStatus();
        trackAppLocationChange((appLocation) => {
            var _a, _b;
            const { app, submenu, modulePage } = this.state.location;
            const moduleChanged = (appLocation.module &&
                this.state.location.module &&
                appLocation.module != this.state.location.module) ||
                (!appLocation.module && this.state.location.module) ||
                (appLocation.module && !this.state.location.module);
            if (appLocation.app != app ||
                appLocation.submenu != submenu ||
                moduleChanged ||
                appLocation.modulePage != modulePage) {
                this.setState({ location: appLocation });
            }
            if ((_a = this.props.user) === null || _a === void 0 ? void 0 : _a.id) {
                const userId = (_b = this.props.user) === null || _b === void 0 ? void 0 : _b.id;
                setTimeout(() => {
                    persistUserApplicationPath(userId);
                }, 1000);
            }
        });
    }
    componentDidMount() {
        this.setState({
            loginRefreshTimer: window.setInterval(() => this.checkAuthStatus(), 30000),
        });
    }
    componentWillUnmount() {
        if (this.state.loginRefreshTimer)
            window.clearInterval(this.state.loginRefreshTimer);
    }
    static isMainMenuOpen() {
        const cookieValue = getCookieValue(REVO_MAIN_MENU_OPEN_COOKIE);
        const isMobile = window.innerWidth <= revoBreakpoints.mobileLandscape.max;
        return (cookieValue ? cookieValue === "true" : true) && !isMobile;
    }
    appTitle() {
        const { app } = this.state.location;
        switch (app) {
            case "buy":
                return {
                    service: "offer",
                    path: "buyer",
                    text: this.menuTranslations.apps.buy.title,
                };
            case "phantomMenu":
                return { service: "phantom-menu", path: "", text: "Phantom menu" };
            case "admin":
                return {
                    service: "lana",
                    path: "company/settings",
                    text: this.menuTranslations.apps.admin.title,
                };
            case "account":
                return {
                    service: "dashboard",
                    path: "",
                    text: this.menuTranslations.apps.account.title,
                };
            case "portfolioAnalyse":
                return {
                    service: "portfolio-analyse",
                    path: "",
                    text: this.menuTranslations.apps.portfolioAnalyse.title,
                };
            case "valuation":
                return {
                    service: "valuation",
                    path: "",
                    text: this.menuTranslations.apps.valuation.title,
                };
            case "locationAnalytics":
                return {
                    service: "lana",
                    path: "assessments",
                    text: this.menuTranslations.apps.locationAnalytics.title,
                };
            default:
                app !== "???" &&
                    console.error(`App ${app} has no app title! Please implement!`);
                return null;
        }
    }
    checkAuthStatus() {
        const call = {
            domain: this.state.domain,
            serviceName: "login",
            pathWithoutLeadingSlash: "api/refreshToken",
        };
        this.setState({ isLoadingAuthorization: true });
        axiosCallWithLocalhostFallback(call, { withCredentials: true }, {}, this.state.localPingResponse)
            .then((response) => {
            this.setState({ isLoadingAuthorization: false });
            if (Math.trunc(response.status / 100) === 2) {
                this.setAuthorizedAndUpdateScopes();
            }
            else if (response.status === 401) {
                this.setState({ isAuthorized: false });
            }
        })
            .catch((err) => {
            this.setState({ isLoadingAuthorization: false });
            console.error("Auth check failed: ", err);
        });
    }
    setAuthorizedAndUpdateScopes() {
        var _a;
        const scopesFromCookies = scopesFromCookie();
        if (JSON.stringify(scopesFromCookies) !== JSON.stringify(this.state.scopes)) {
            reportAppScopesChanges(scopesFromCookies);
            this.setState({ scopes: scopesFromCookies });
        }
        if (getServiceName(window.location) === "lana" &&
            !((_a = userApps.locationAnalytics) === null || _a === void 0 ? void 0 : _a.scopeRequirements(scopesFromCookies))) {
            window.location.href = `${betterServiceUrl("dashboard", "profile")}`;
        }
        this.setState({ isAuthorized: true });
    }
    toggleMainMenu() {
        const newState = !this.state.mainMenuOpen;
        this.setState({ mainMenuOpen: newState });
        const inOneYear = new Date();
        inOneYear.setFullYear(new Date().getFullYear() + 1);
        setCookie(REVO_MAIN_MENU_OPEN_COOKIE, `${newState}`, inOneYear, getSanitizedDomain(window.location));
    }
    openMenu() {
        if (!this.hoverDelayTimer) {
            this.hoverDelayTimer = window.setTimeout(() => this.setState({ isHovered: true }), this.HOVER_DELAY_TIMEOUT);
        }
    }
    closeMenu() {
        clearInterval(this.hoverDelayTimer);
        this.hoverDelayTimer = undefined;
        this.setState({ isHovered: false });
    }
    render() {
        const { mainMenuOpen } = this.state;
        const appTitle = this.appTitle();
        return (React.createElement("div", { className: "revoAppDrawer" },
            React.createElement("div", { className: "revoAppDrawer__pushedArea" },
                React.createElement("div", { className: "revoMenu__menuWrapper" },
                    React.createElement(RevoMainMenu, { user: this.props.user, open: this.state.location.app !== "???" && mainMenuOpen, overlay: this.state.location.app !== "???" && this.state.isHovered, location: this.state.location, appTitle: appTitle ? appTitle.text : "", toggleMainMenu: this.toggleMainMenu, toggleAppDrawer: () => this.setState({ appDrawerOpen: !this.state.appDrawerOpen }), onMouseEnter: () => this.openMenu(), onMouseLeave: () => this.closeMenu(), menuIsHovered: this.state.isHovered, scopes: this.state.scopes }),
                    React.createElement("div", { className: "revoMenu__contentWrapper" },
                        React.createElement("div", { id: "revo-content" }))),
                !this.state.isAuthorized && !this.state.isLoadingAuthorization && (React.createElement(SessionExpiredPortal, { onWindowVisible: this.checkAuthStatus })))));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RevoLoggedInMenu.prototype, "checkAuthStatus", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RevoLoggedInMenu.prototype, "setAuthorizedAndUpdateScopes", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RevoLoggedInMenu.prototype, "toggleMainMenu", null);
//# sourceMappingURL=revo-loggedin-menu.js.map